export default __webpack_public_path__ + "static/media/icon_8_1.3e16ae54.svg";